export interface CsRadioInterface {
  deselect(): void;
  refreshSelection(): void;
}

export class CsRadioBase implements CsRadioInterface {
  refreshSelection(): void {
    throw new Error("Method not implemented.");
  }
  deselect(): void {
    throw new Error("Method not implemented.");
  }
}
